import React, { useState } from 'react'
import { FaEye, FaFileInvoiceDollar, FaPrint } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { homeUrl } from '../../utils/api'
import { ConvertDate } from '../../utils/dateFormat'
import { InvoicePreview } from '../InvoicePDF/InvoicePreview'
import SkeletonLoader from '../Resources/SkeletonLoader/SkeletonLoader'
import TableV1 from '../Resources/TableV1/TableV1'
import TitleContainer from '../Resources/TitleContainer/TitleContainer'
import classes from './OrderList.module.css'
import Modal from './PDFModal/Modal'
import Popup from './Popup/Popup'

// import StatusPopup from './StatusPopup/StatusPopup'

const OrderList = ({
    products,
    loading,
    totalResults,
    setOrderNumber,
    orderProducts,
    loading1,
    customerUserId, // Receive customerUserId prop
}) => {
    const [meta, data] = products

    const [popup, setPopup] = useState(false)
    const [selectedOrder, setSelectedOrder] = useState(null)
    const [showInvoice, setShowInvoice] = useState(false)
    const [showPOS, setShowPOS] = useState(false)
    // const [popupStatus, setPopupStatus] = useState(false)

    const handlePopup = () => {
        setPopup(!popup)
    }

    // const handlePopupStatus = () => {
    //     setPopupStatus(!popupStatus)
    // }

    function removeSpace(str) {
        return str.trim().toLowerCase().replace(/\s+/g, '-')
    }

    // Create dynamic title based on whether filtering by customer
    const getTitle = () => {
        if (customerUserId) {
            return `Orders for Customer ID: ${customerUserId}`
        }
        return 'Order List'
    }

    return (
        <div className={classes.container}>
            <TitleContainer title={getTitle()} isCount={true} count={totalResults} />
            <div>
                <TableV1>
                    <thead>
                        <tr className={`${classes.tableRow}`}>
                            <th>SL</th>
                            <th>Order No</th>
                            {/* <th>Customer</th> */}
                            {/* <th>Customer Id</th> */}
                            <th>Seller</th>
                            <th>Total Price(tk)</th>
                            <th>Quantity</th>
                            <th>Order Date</th>
                            <th>Delivery</th>
                            <th>Payment</th>
                            <th>Order Status</th>
                            <th className={classes.actionHeader}>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <SkeletonLoader row={10} column={11} />
                        ) : data && data.length > 0 ? (
                            data.map((item, index) => {
                                const { Order, Seller, OrderShipment } = item

                                return (
                                    <tr key={index} className={classes.tableData}>
                                        <td>{index + 1}</td>
                                        <td>{Order.order_number}</td>
                                        {/* <td>
                                            {OrderShipment.customer_name} <br /> {OrderShipment.customer_phone}
                                        </td> */}
                                        {/* <td>{Order.customer_user_id}</td> */}
                                        <td>
                                            <Link
                                                to={`${homeUrl}/companies/${Seller.seller_full_id}/${removeSpace(
                                                    Seller.page_name
                                                )}`}
                                                className={classes.productShop}
                                                target="_blank">
                                                {Seller.page_name}
                                            </Link>
                                        </td>
                                        <td>{Order.payable_price}</td>
                                        <td>{Order.total_order_quantity || 0}</td>
                                        <td>{ConvertDate(Order.order_date)}</td>
                                        <td>
                                            <span
                                                className={`${classes.badge} ${
                                                    OrderShipment.shipment_status === 'delivered'
                                                        ? classes.completed
                                                        : OrderShipment.shipment_status === 'pending'
                                                        ? classes.pending
                                                        : classes.inProgress
                                                }`}>
                                                {OrderShipment.shipment_status}
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                className={`${classes.badge} ${
                                                    Order.payment_status === 'completed'
                                                        ? classes.completed
                                                        : Order.payment_status === 'pending'
                                                        ? classes.pending
                                                        : classes.inProgress
                                                }`}>
                                                {Order.payment_status}
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                className={`${classes.badge} ${
                                                    Order.order_status === 'completed'
                                                        ? classes.completed
                                                        : Order.order_status === 'pending'
                                                        ? classes.pending
                                                        : Order.order_status === 'processing'
                                                        ? classes.inProgress
                                                        : Order.order_status === 'cancelled'
                                                        ? classes.cancelled
                                                        : ''
                                                }`}>
                                                {Order.order_status}
                                            </span>
                                        </td>
                                        <td className={classes.action}>
                                            <button
                                                onClick={() => {
                                                    setOrderNumber(Order.order_number)
                                                    handlePopup()
                                                }}>
                                                <FaEye size={16} />
                                            </button>
                                            <button
                                                title="invoice"
                                                className={classes.invoiceIcon}
                                                onClick={() => {
                                                    setOrderNumber(Order.order_number)
                                                    setSelectedOrder(item)
                                                    setShowInvoice(true)
                                                }}>
                                                <FaPrint size={16} color="var(--green)" />
                                            </button>
                                            {/* <button()
                                                title="label"
                                                className={classes.posIcon}
                                                onClick={() => {
                                                    setOrderNumber(Order.order_number)
                                                    setSelectedOrder(item)
                                                    setShowPOS(true)
                                                }}>
                                                <FaPrint size={16} />
                                            </button> */}
                                        </td>
                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td colSpan="11" className={classes.tableNotFound}>
                                    <h2>
                                        {customerUserId
                                            ? `No orders found for Customer ID: ${customerUserId}`
                                            : 'No Data Found'}
                                    </h2>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </TableV1>
            </div>
            {popup && <Popup setForm={setPopup} form={popup} orderProducts={orderProducts} loading1={loading1} />}
            {showInvoice && selectedOrder && (
                <Modal onClose={() => setShowInvoice(false)} invoiceNumber={selectedOrder.Order?.order_number}>
                    <InvoicePreview
                        invoiceNumber={selectedOrder.Order?.order_number}
                        date={ConvertDate(selectedOrder.Order?.order_date)}
                        clientName={selectedOrder.OrderShipment?.customer_name}
                        orderProducts={orderProducts}
                        selectedOrder={selectedOrder}
                    />
                </Modal>
            )}
        </div>
    )
}

export default OrderList
